exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".spark-message {\n  background: white; }\n  .spark-message.no-background {\n    background: none; }\n  .spark-message.no-border-panel {\n    border: none; }\n  .spark-message .spark-panel__content.spark-panel__no-padding {\n    padding: 0; }\n  .spark-message .spark-message__content.spark-message__inline {\n    display: inline-flex; }\n    .spark-message .spark-message__content.spark-message__inline .spark-message__heading:after {\n      content: \" \";\n      margin-left: .5rem; }\n  .spark-message .spark-panel__content .message__icon--xl {\n    font-size: 2rem;\n    height: 4rem;\n    min-height: 4rem;\n    min-width: 4rem;\n    padding: 0 1rem;\n    width: 4rem; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader?sourceMap!./src/components/message/message.scss
// module id = 1364
// module chunks = 0